<template>
  <quill-editor v-model:content="data.value" :toolbar="toolbar" content-type="html" theme="snow"/>

  <!-- Hidden input field to include name -->
  <input type="hidden" :name="name" :value="data.value"/>
</template>

<script>
/**
 *
 * Component used in bsquilleditor Form widget.
 *
 *
 * Example:
 *
 * <bs-quilleditor name="email_signature"
 *                 toolbar="full"
 *                 model-value="{{ old($name) ?: $value }}">
 * </bs-quilleditor>
 */

export default {
  props: {
    /**
     * Field name.
     */
    name: {
      type: String,
      required: true
    },
    /**
     * Initial value.
     */
    modelValue: {
      type: String,
      default: () => {
        return '';
      }
    },
    /**
     * Pre-configured toolbar options.
     * Available options: essential, minimal, full, and "" to use default options.
     */
    toolbar: {
      type: String,
      default: () => {
        return 'full';
      }
    },
  },

  data() {
    return {
      data: {
        value: this.modelValue,
      }
    };
  },
};
</script>

